var o={MuiFormGroup:{row:{"& .MuiFormControlLabel-root":{marginRight:24}}}};export{o as default};
